<div class="send-email-preview">
  

  <div class="preview-section">
    <div class="preview-label">{{ 'julia.email_preview.to' | translate }}:</div>
    <div class="preview-value">
      <span *ngIf="emailData.params.to">{{ emailData.params.to }}</span>
      <span *ngIf="emailData.params.recipients">{{ emailData.params.recipients }}</span>
      <span *ngIf="!emailData.params.to && !emailData.params.recipients">{{ 'julia.email_preview.not_specified' | translate }}</span>
    </div>
  </div>

  <!-- <div class="preview-section" *ngIf="emailData.cc">
    <div class="preview-label">CC:</div>
    <div class="preview-value">{{ emailData.cc }}</div>
  </div>

  <div class="preview-section" *ngIf="emailData.bcc">
    <div class="preview-label">BCC:</div>
    <div class="preview-value">{{ emailData.bcc }}</div>
  </div> -->

  <div class="preview-section">
    <div class="preview-label">{{ 'julia.email_preview.subject' | translate }}:</div>
    <div class="preview-value preview-subject">{{ emailData.params.subject || ('julia.email_preview.no_subject' | translate) }}</div>
  </div>

  <div class="preview-section">
    <div class="preview-label">{{ 'julia.email_preview.message' | translate }}:</div>
    <div class="preview-value preview-body">
      <div *ngIf="emailData.params.body " [innerHTML]="emailData.params.body"></div>
      <div *ngIf="!emailData.params.body ">{{ 'julia.email_preview.no_message' | translate }}</div>
    </div>
  </div>

  
</div>
